import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import {TranslateConfigService} from "@app/services/translate-config.service";

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {

    constructor(private translateConfigService: TranslateConfigService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const lang = this.translateConfigService.getCurrentLanguage();
        const cloned = req.clone({
            setHeaders: {
                'Accept-Language': lang
            }
        });
        return next.handle(cloned);
    }
}
